import Toastify from "toastify-js";

export function toastOk(text: string) {
  Toastify({
    text,
    style: {
      background: "#28a745",
      color: "#ffffff",
    },
    duration: 3000,
  }).showToast();
}

export function toastErr(text: string) {
  Toastify({
    text,
    style: {
      background: "#dc3545",
      color: "#ffffff",
    },
    duration: 3000,
  }).showToast();
}

export function toastWarn(text: string) {
  Toastify({
    text,
    style: {
      background: "#ffc107",
      color: "#212529",
    },
    duration: 3000,
  }).showToast();
}
